/**
 * Web push (Enable Notifications banner, FCM register-device, foreground toasts).
 * Temporarily off while splitting deploy — set to `true` to re-enable.
 */
export const FCM_WEB_PUSH_ENABLED = true;
